var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "home-hero" },
    [
      _c("div", {
        staticClass: "home-hero__bg",
        class: { "is-video": _vm.serviceID != null },
      }),
      _vm._v(" "),
      _vm.content.background_type != "video" && _vm.content.background_image.url
        ? _c("img", {
            staticClass: "home-hero__bg__img",
            attrs: { src: _vm.content.background_image.url, alt: "" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.content.background_type === "video" && _vm.content.background_video
        ? _c("div", { staticClass: "home-hero__video home-hero__video--bg" }, [
            _c("video", {
              attrs: {
                src: _vm.content.background_video,
                loop: "",
                playsinline: "",
                muted: "",
              },
              domProps: { muted: true },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "home-hero__container container" }, [
        _c("div", { staticClass: "home-hero__wrapper" }, [
          _c("div", { staticClass: "home-hero__content" }, [
            _c("div", {
              staticClass: "heading-small",
              domProps: { innerHTML: _vm._s(_vm.content.heading_small_left) },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "home-hero__title" }, [
              _vm._v("\n                    " + _vm._s(_vm.content.title)),
              _c("span", [_vm._v(".")]),
            ]),
            _vm._v(" "),
            _vm.content.video_button_label &&
            _vm.content.showreel_video &&
            _vm.content.video_button_label != ""
              ? _c(
                  "button",
                  {
                    staticClass: "home-hero__popup-button",
                    on: {
                      click: function ($event) {
                        return _vm.showPopup()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.content.video_button_label))]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "home-hero__nav" },
            [
              _c("div", {
                staticClass: "heading-small",
                domProps: {
                  innerHTML: _vm._s(_vm.content.heading_small_right),
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.content.services, function (link) {
                return _c(
                  "div",
                  {
                    key: link.service[0].ID,
                    staticClass: "home-hero__nav__item",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "home-hero__nav__link",
                        attrs: {
                          href: "/services/" + link.service[0].post_name,
                          title: link.service[0].post_title,
                        },
                        on: {
                          mouseenter: function ($event) {
                            return _vm.hover(link.service[0].ID)
                          },
                          mouseleave: function ($event) {
                            _vm.serviceID = null
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "home-hero__nav__link__text" },
                          [_vm._v(_vm._s(link.service[0].post_title))]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "home-hero__nav__link__text home-hero__nav__link__text--hover",
                          },
                          [_vm._v(_vm._s(link.service[0].post_title))]
                        ),
                      ]
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.content.showreel_video && _vm.isPopupOpenned,
                expression: "content.showreel_video && isPopupOpenned",
              },
            ],
            staticClass: "home-hero__popup",
          },
          [
            _c(
              "svg",
              {
                staticClass: "home-hero__popup__play-icon",
                attrs: { viewBox: "0 0 14 15" },
                on: {
                  click: function ($event) {
                    return _vm.playPopup()
                  },
                },
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      transform: "translate(14) rotate(90)",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: { d: "M7.5,0,15,14H0Z", stroke: "none" },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M 7.500000476837158 2.117650032043457 L 1.670169830322266 13.00000095367432 L 13.32983112335205 13.00000095367432 L 7.500000476837158 2.117650032043457 M 7.500000476837158 9.5367431640625e-07 L 15 14.00000095367432 L 9.5367431640625e-07 14.00000095367432 L 7.500000476837158 9.5367431640625e-07 Z",
                        stroke: "none",
                        fill: "#000",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("video", {
              attrs: { id: "popupVideo", src: _vm.content.showreel_video },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "home-hero__popup__close_button is-active",
                on: {
                  click: function ($event) {
                    return _vm.hidePopup()
                  },
                },
              },
              [_c("span"), _vm._v(" "), _c("span"), _vm._v(" "), _c("span")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "home-hero__popup__controls" }, [
              _c(
                "button",
                {
                  staticClass: "home-hero__popup__btn",
                  class: { isToggled: !_vm.isPopupVideoPaused },
                  on: {
                    click: function ($event) {
                      return _vm.tooglePopupPlay()
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "14",
                        height: "15",
                        viewBox: "0 0 14 15",
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "Polygon_2",
                            "data-name": "Polygon 2",
                            transform: "translate(14) rotate(90)",
                            fill: "none",
                          },
                        },
                        [
                          _c("path", {
                            attrs: { d: "M7.5,0,15,14H0Z", stroke: "none" },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M 7.500000476837158 2.117650032043457 L 1.670169830322266 13.00000095367432 L 13.32983112335205 13.00000095367432 L 7.500000476837158 2.117650032043457 M 7.500000476837158 9.5367431640625e-07 L 15 14.00000095367432 L 9.5367431640625e-07 14.00000095367432 L 7.500000476837158 9.5367431640625e-07 Z",
                              stroke: "none",
                              fill: "#fff",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "13",
                        height: "15",
                        viewBox: "0 0 13 15",
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "Group_2",
                            "data-name": "Group 2",
                            transform: "translate(1698 -1036)",
                          },
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "Rectangle_312",
                                "data-name": "Rectangle 312",
                                transform: "translate(-1698 1036)",
                                fill: "none",
                                stroke: "#fff",
                                "stroke-width": "1",
                              },
                            },
                            [
                              _c("rect", {
                                attrs: {
                                  width: "5",
                                  height: "15",
                                  stroke: "none",
                                },
                              }),
                              _vm._v(" "),
                              _c("rect", {
                                attrs: {
                                  x: "0.5",
                                  y: "0.5",
                                  width: "4",
                                  height: "14",
                                  fill: "none",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "Rectangle_313",
                                "data-name": "Rectangle 313",
                                transform: "translate(-1690 1036)",
                                fill: "none",
                                stroke: "#fff",
                                "stroke-width": "1",
                              },
                            },
                            [
                              _c("rect", {
                                attrs: {
                                  width: "5",
                                  height: "15",
                                  stroke: "none",
                                },
                              }),
                              _vm._v(" "),
                              _c("rect", {
                                attrs: {
                                  x: "0.5",
                                  y: "0.5",
                                  width: "4",
                                  height: "14",
                                  fill: "none",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "home-hero__popup__btn",
                  class: { isToggled: _vm.isPopupVideoMuted },
                  on: {
                    click: function ($event) {
                      return _vm.tooglePopupSound()
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 29.89 24.3",
                      },
                    },
                    [
                      _c("rect", {
                        attrs: {
                          fill: "none",
                          stroke: "#ffffff",
                          "stroke-miterlimit": "10",
                          x: "0.5",
                          y: "7.54",
                          width: "4.66",
                          height: "9.59",
                        },
                      }),
                      _vm._v(" "),
                      _c("polygon", {
                        attrs: {
                          fill: "none",
                          stroke: "#ffffff",
                          "stroke-miterlimit": "10",
                          points:
                            "5.15 7.54 14.74 0.95 14.74 23.38 5.15 17.12 5.15 7.54",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          fill: "none",
                          stroke: "#ffffff",
                          "stroke-miterlimit": "10",
                          d: "M20.22,6.79l.11.11a7.72,7.72,0,0,1,.06,10.63",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          fill: "none",
                          stroke: "#ffffff",
                          "stroke-miterlimit": "10",
                          d: "M23.15,5.65a9.83,9.83,0,0,1,.1,13",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          fill: "none",
                          stroke: "#ffffff",
                          "stroke-miterlimit": "10",
                          d: "M26.33,3.86a13,13,0,0,1,.12,16.61",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 28.71 24.3",
                      },
                    },
                    [
                      _c("rect", {
                        attrs: {
                          fill: "none",
                          stroke: "#ffffff",
                          "stroke-miterlimit": "10",
                          x: "0.5",
                          y: "7.54",
                          width: "4.66",
                          height: "9.59",
                        },
                      }),
                      _vm._v(" "),
                      _c("polygon", {
                        attrs: {
                          fill: "none",
                          stroke: "#ffffff",
                          "stroke-miterlimit": "10",
                          points:
                            "5.16 7.54 14.75 0.95 14.75 23.38 5.16 17.12 5.16 7.54",
                        },
                      }),
                      _vm._v(" "),
                      _c("line", {
                        attrs: {
                          fill: "none",
                          stroke: "#ffffff",
                          "stroke-miterlimit": "10",
                          x1: "20.4",
                          y1: "8.42",
                          x2: "28.36",
                          y2: "16.39",
                        },
                      }),
                      _vm._v(" "),
                      _c("line", {
                        attrs: {
                          fill: "none",
                          stroke: "#ffffff",
                          "stroke-miterlimit": "10",
                          x1: "28.36",
                          y1: "8.42",
                          x2: "20.4",
                          y2: "16.39",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }